import Signal from "./signal";
import PropTypes from "prop-types";

const UNIVERSAL_PDP_THRESHOLD_FOR_URGENCY = 3;

export function calculateEligiblityToShowUrgencySignalOnUniversalPdp(
  availability,
  selectedSku,
  thresholdForUrgency = UNIVERSAL_PDP_THRESHOLD_FOR_URGENCY
) {
  if (!(Array.isArray(availability) && availability.length > 0 && !!selectedSku)) {
    return { isEligible: false, availabilityOfSelectedSku: 0 };
  }

  const availabilityOfSelectedSku = availability.find(o => o?.sku === selectedSku)?.availableCount;

  const isEligible =
    Number.isInteger(availabilityOfSelectedSku) &&
    Number.isInteger(thresholdForUrgency) &&
    availabilityOfSelectedSku > 0 &&
    availabilityOfSelectedSku <= thresholdForUrgency;

  return { isEligible, availabilityOfSelectedSku };
}

export default function UrgencySignalWrapper({
  thresholdForUrgency = UNIVERSAL_PDP_THRESHOLD_FOR_URGENCY,
  availability,
  selectedSku,
  className,
}) {
  const { isEligible, availabilityOfSelectedSku } = calculateEligiblityToShowUrgencySignalOnUniversalPdp(
    availability,
    selectedSku,
    thresholdForUrgency
  );

  if (!isEligible) {
    return;
  }

  return (
    <Signal itemLeft={availabilityOfSelectedSku} thresholdForUrgency={thresholdForUrgency} className={className} />
  );
}

UrgencySignalWrapper.propTypes = {
  thresholdForUrgency: PropTypes.number,
  availability: PropTypes.arrayOf(PropTypes.object),
  selectedSku: PropTypes.string,
  className: PropTypes.string.isRequired,
};
